var app = angular.module('directives.promoterScore', []);

require('./directives/score.js');
require('./templates/index.html');
require('./stylesheets/style.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/promoterScore/index.js
 ** module id = 214
 ** module chunks = 1
 **/